"use strict";
exports.__esModule = true;
exports.SelfPayPaymentMethods = void 0;
var SelfPayPaymentMethods;
(function (SelfPayPaymentMethods) {
    SelfPayPaymentMethods["VIRTUAL_CARD"] = "virtual card";
    SelfPayPaymentMethods["BANK_ACCOUNT"] = "bank account";
    SelfPayPaymentMethods["DEBIT_CARD"] = "debit card";
})(SelfPayPaymentMethods = exports.SelfPayPaymentMethods || (exports.SelfPayPaymentMethods = {}));
